export default __webpack_public_path__ + "static/media/ExamIcon.cc8b4c70.svg";